<template>
  <div class="contact">

    <div :class="[isMobile ? 'news-title-mobile' : 'news-title']">
      <label :class="[isMobile ? 'news-msg-mobile' : 'news-msg']">聯絡我們</label>
    </div>

      <div :class="[isMobile ? 'contact-item-mobile' : 'contact-item']">
        <img style="width:30px;height:30px" src="../assets/address.png">
        <div class="contact-right">
          <label style="font-size:16px;color:#301E03">辦事處地址：</label>
         <label class="myfont-family" style="font-size:16px;color:#301E03;margin-top: 5px;">{{netConfig['site_address']}}</label>
        </div>
      </div>


      <div :class="[isMobile ? 'contact-item-mobile' : 'contact-item']">
        <img style="width:30px;height:30px" src="../assets/phone.png">
        <div class="contact-right">
          <label style="font-size:16px;color:#301E03">聯絡電話（秘書處）：</label>
         <label class="myfont-family" style="font-size:16px;color:#301E03;margin-top: 5px;" >{{netConfig['site_phone']}}</label>
        </div>
      </div>



      <div :class="[isMobile ? 'contact-item-mobile' : 'contact-item']">
        <img style="width:30px;height:30px" src="../assets/fax.png">
        <div class="contact-right">
          <label style="font-size:16px;color:#301E03">傳真：</label>
         <label class="myfont-family" style="font-size:16px;color:#301E03;margin-top: 5px;">{{netConfig['site_fax']}}</label>
        </div>
      </div>


      <div :class="[isMobile ? 'contact-item-mobile' : 'contact-item']">
        <img style="width:30px;height:30px" src="../assets/message.png">
        <div class="contact-right">
          <label style="font-size:16px;color:#301E03">電子郵箱：</label>
         <label style="font-size:16px;color:#301E03;margin-top: 5px;">{{netConfig['site_email']}}</label>
        </div>
      </div>

  </div>
</template>


<script>

export default {
  name: 'Contact',
  data() {
    return {
      // netConfig: window.netConfig || {},
      isMobile: false
    }
  },
  props:{
    netConfig:{}
  },
  created() {
    this.isMobile = window.isMobile
  },
  mounted() {
    //  console.log('window.netConfig ' + JSON.stringify(window.netConfig));
  },
  methods: {

  },
}
</script>


<style lang="scss" rel="stylesheet/scss" scoped>
.contact {
  align-items: center;
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 44px;


.news-title {
  box-sizing: border-box;
  padding-left: 6%;
    margin-top: 30px;
    width: 1040px;
    display: flex;

    .news-msg {
      font-size: 28px;
      color: #301E03
    }
  }

  .news-title-mobile {
    box-sizing: border-box;
    padding-left: 20px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .news-msg-mobile {
      font-size: 22px;
      color: #301E03
    }
  }

.contact-item{
  box-sizing: border-box;
  padding-left: 7%;
  width: 1040px;
  margin-top: 40px;
  display: flex;
  align-items: center;

  .contact-right{
    margin-left: 24px;
    display: flex;
    flex-direction: column;
  }
}

.contact-item-mobile{
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
  padding-left: 35px;
  display: flex;
  align-items: center;

  .contact-right{
    margin-left: 24px;
    display: flex;
    flex-direction: column;
  }
}

.myfont-family{
  font-family: "Microsoft YaHei",Tahoma, Helvetica, Arial;
}


}
</style>
